/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface RoutersIdVpnConnectionUsernameDelete$Params {

/**
 * The id of a router
 */
  id: string;

/**
 * The name of a user
 */
  username: string;
}

export function routersIdVpnConnectionUsernameDelete(http: HttpClient, rootUrl: string, params: RoutersIdVpnConnectionUsernameDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, routersIdVpnConnectionUsernameDelete.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('username', params.username, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

routersIdVpnConnectionUsernameDelete.PATH = '/routers/{id}/vpn-connection/{username}';
